import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

const domain = window.location.host;
const APP_LOCAL_PATH = "developer.gartner.com";
const chartSquareLength = Math.round(window.innerHeight * 0.8);

const GENIE_AUTH_ENV = {
  LOCAL: "http://toolsdv.gartner.com/account/signin",
};

let API_PATH = "";
if (domain.indexOf("developer.gartner.com") !== -1) {
  API_PATH = "https://toolsdv.gartner.com";
}

export const Constants = {
  LOGOUT_EVENT_KEY: 'logout-event', // This should match the key in mercury-header-app
  GENIE_ACCESS_CODE: "genie_uid",
  IMAGES: {
    FOLDER_PATH: "/assets/common/mercury/images",
    PPT_FOLDER_PATH: "/assets/common/mercury/ppt-images",
    EXPERT_AVATAR_1: "/expert-avatar-1.webp",
    EXPERT_AVATAR_2: "/expert-avatar-2.webp",
    EXPERT_AVATAR_3: "/expert-avatar-3.webp",
    EXPERT_AVATAR_4: "/expert-avatar-4.webp",
    EMPTY_SCORECARD: "/empty-score-card.png",
    WHATS_NEXT_DASHBOARD: "/whats-next-dashboard.svg",
    WHATS_NEXT_USE_CASE_DESKTOP: "/whats-next-usecase-desktop.svg",
    WHATS_NEXT_USE_CASE_TABLET: "/whats-next-usecase-tablet.svg",
    WHATS_NEXT_USE_CASE_DETAILS: "/whats-next-usecase-details.svg",
    CASE_STUDY_HAND: "/case-study-hand.png",
    CASE_STUDY_INFO: "/case-study-info.png",
    GARTNER_DARK_LOGO: "/gartner-dark-logo.png",
    GARTNER_LIGHT_LOGO: "/gartner-light-logo.png",
    GRAPH_OUTLINE: "/graph-outline.png",
    HOW_TO_USE_GRAPH: "/how-to-use-graph.png",
    HOW_TO_USE_GRAPH_WITH_CONTENT: "/how-to-use-graph-content.png",
    ASSESSMENT_DASHBOARD_CARD: "/assessment-dashboard-card.png",
  },
  API: {
    API_PATH: API_PATH,
    LOGIN: "/api/use-case-insights/v1/login",
    USE_CASE: "/api/use-case-insights/v1/search/use-case",
    SEARCH_FILTERS: "/api/use-case-insights/v1/search/filter",
    SEARCH_SUGGESTION: "/api/use-case-insights/v1/search/suggestion",
    USE_CASE_SEMANTIC_SEARCH: "/api/use-case-insights/v2/search/use-case",
    USE_CASE_SEMANTIC_FILTER: "/api/use-case-insights/v2/filter/use-case",
    USE_CASE_DETAIL: "/api/use-case-insights/v1/use-case",
    SAVE: "/save",
    USE_CASE_CASE_STUDY: "/case-study/",
    RELATED: "/related",
    CUSTOMIZE_WEIGHTS: "/api/use-case-insights/v1/weight",
    RESET_WEIGHTS: "/score-card/reset-weight/",
    SHARE_MAIL_VALIDATE: "/share/validate",
    SHARE_MAIL: "/share",
    SCORE_CARD: "/api/use-case-insights/v1/score-card",
    USE_CASE_TERM: "/use-case",
    SCORE_CARD_EXPORT_EXCEL: "export",
    SCORE_CARD_TERM: "/score-card/",
    SCORE_CARD_FILTER: "/filter",
    SCORE_CARD_TOGGLE_TO_GRAPH: "/toggle-added-to-graph-flag",
    SCORE_CARD_CALLOUT: '/score-card/callout/',
    TEAM_MEMBERS: '/api/use-case-insights/v1/team/members',
    DELETE_TEAM_MEMBER: '?email=',
    VALID_MAIL: '/api/use-case-insights/v1/license/validate',
    TEAM_SHARE: '/api/use-case-insights/v1/team/share',
    CASE_EXAMPLES: "/api/use-case-insights/v1/case-study",
    SEARCH: "/search/",
    FILTER: "/filter/",
    CASE_EXAMPLES_SUGGESTION: "/api/use-case-insights/v1/case-study/search/suggestion",
    CASE_EXAMPLES_SEMANTIC_SEARCH: "/api/use-case-insights/v2/search/case-study/",
    CASE_EXAMPLES_SEMANTIC_FILTER: "/api/use-case-insights/v2/filter/case-study/",
    HOME_PAGE: "/api/use-case-insights/v1/home",
    HOME_BANNER: "/library-stats",
    FEATURED_USE_CASE: "/featured/use-case",
    FEATURED_CASE_EXAMPLES: "/featured/case-study",
    USE_CASE_ASSESSMENTS: "/api/use-case-insights/v1/assessment/default",
    GARTNER_ASSESSMENT_DETAILS: "/api/use-case-insights/v1/assessment/",
    CREATE_YOUR_ASSESSMENT: "/assessment",
    IMPORT_USE_CASES: {
      DONWLOAD: "template",
      UPLOAD: "import",
      ROW: "row",
      COMMIT: "commit",
      SCORE: "score",
    },
    CUSTOM_USE_CASES: "custom-use-case",
    CUSTOM_USE_CASES_DD_OPTIONS: "lookups",
    CUSTOM_USE_CASES_UNDO: "restore"
  },
  TABS_INDEX_PAIR: [
    { PATH: "/use-case-insights", INDEX: 0 },
    { PATH: "/use-case-insights/usecases/detail", INDEX: 1 },
    { PATH: "/use-case-insights/usecases", INDEX: 1 },
    { PATH: "/use-case-insights/dashboard", INDEX: 2 },
    { PATH: "/use-case-insights/scorecard", INDEX: 2 },
    { PATH: "/use-case-insights/gartner-assessments", INDEX: 2 },
    { PATH: "/use-case-insights/case-examples/detail", INDEX: 3 },
    { PATH: "/use-case-insights/case-examples", INDEX: 3 },
  ],
  TABS: ["HOME_PAGE", "USE_CASES", "SCORE_CARDS", "CASE_EXAMPLES"],
  TABS_INFO: { 
    HOME_PAGE: {
      LABEL: 'Homepage',
      ROUTE: `/use-case-insights`,
      INDEX: 0,
      ICON: HomeOutlinedIcon,
    },
    USE_CASES: {
      LABEL: 'Use Cases',
      ROUTE: `/use-case-insights/usecases`,
      INDEX: 1,
      ICON: ArticleOutlinedIcon,
    },
    SCORE_CARDS: {
      LABEL: 'Assessments',
      ROUTE: `/use-case-insights/dashboard`,
      INDEX: 2,
      ICON: DashboardOutlinedIcon,
    },
    CASE_EXAMPLES: {
      LABEL: 'Case Examples',
      ROUTE: `/use-case-insights/case-examples`,
      INDEX: 3,
      ICON: LibraryBooksOutlinedIcon,
    }
  },
  ROUTES: {
    APP_LOCAL_PATH,
    GENIE_AUTH_URL: GENIE_AUTH_ENV.LOCAL,
    BASE_URL: "/use-case-insights",
    USE_CASES: "/usecases",
    DASHBOARD: "/dashboard",
    SCORECARD: "/scorecard",
    GARTNER_ASSESSMENTS: "/gartner-assessments",
    DETAIL: "/detail/",
    CASE_EXAMPLES: "/case-examples",
    ID_PARAM: "?id=",
    SLUG_PARAM: ":slug",
    ACCESS_DENIED: "/access-denied",
    IMPORT_USE_CASES: "/import"
  },
  ROUTES_BROWSER_TITLE: {
    HOME: "AI Use Case Insights : Home Page",
    USE_CASE: "AI Use Case Insights : Use Cases",
    DASHBOARD: "AI Use Case Insights : Dashboard",
    SCORECARD: "AI Use Case Insights : Scorecard",
    IMPORT_USE_CASES: "AI Use Case Insights : Scorecard - Import Usecases",
    GARTNER_ASSESSMENTS: "AI Use Case Insights : Gartner Assessments",
    USE_CASE_INSIGHTS: "AI Use Case Insights : ",
    CASE_EXAMPLES: "AI Use Case Insights : Case Examples",
  },
  ROLE: ["client", "gartner_associate"],
  GUEST_ROLE: "guest",
  CLIENT_ROLE: "client",
  GARTNER_ASSOCIATE_ROLE: "gartner_associate",
  SUBHEADER: {
    FIRST_LINE: "AI Use Cases to Drive Business Impact",
    SECOND_LINE:
      "Stay ahead in the fast-paced world of AI with objective insights into curated Use Cases.",
  },
  FILTERSECTION: {
    USE_CASES_FIELDS: [
      "businessFunctions",
      "subFunctions",
      "industries",
      "subIndustries",
      "implementationGuide",
      "businessValues",
      "businessValueRatings",
      "feasibilityRatings",
      "useCaseCategories",
      "zodiacCategory"
    ],
    USE_CASES_FIELDS_EXPAND: {
      "businessFunctions": true,
      "industries": true,
    },
    FIELD_ENUM: {
      INDUSTRIES: "industries",
      BUSINESS_FUNCTIONS: "businessFunctions",
      SUB_INDUSTRIES: "subIndustries",
    },
    FIELDS_LABEL: {
      businessFunctions: "Business Function",
      subFunctions: "Sub-Function",
      industries: "Industry",
      subIndustries: "Sub-Industry",
      implementationGuide: "Implementation Guide",
      businessValues: "Business Outcome",
      businessValueRatings: "Value Rating",
      feasibilityRatings: "Feasibility Rating",
      useCaseCategories: "Use Case Category",
      valueIndicators: "Value Driver",
      zodiacCategory: "Use Case Family"
    },
    CLEAR_ALL: "Clear All",
    SEARCH_BY_KEYWORD: "Search use cases by keywords",
    RESULTS: "Results",
    USE_CASE: "Use Case",
    SELECT_PLACEHOLDER: "Select...",
    ARE_YOU_LOOKING_FOR: "Are you looking for?",
    CLEAR_FILTERS: "Clear Filters",
    FILTERS: "Filters",
    FILTERS_BY: "Filter by:",
    APPLY: "Apply",
    EMPTY_PLACEHOLDER:
      "No results for '##SEARCH_KEYWORD##'. Please try changing the keywords.",
    SEARCH_KEYWORD_REPLACE: "##SEARCH_KEYWORD##",
    VIEW_MORE: 'View More',
    VIEW_LESS: 'View Less',
    BACK_TO_PAGE: 'Back to',
  },
  SEARCH_FILTER_ENUM: {
    BUSINESS_FUNCTION: "businessFunction",
    SUB_FUNCTION: "subFunction",
    INDUSTRY: "industry",
    SUB_INDUSTRY: "subIndustry",
    IMPLEMENTATION_GUIDE: "implementationGuide",
    BUSINESS_VALUE: "businessValue",
    BUSINESS_VALUE_RATING: "businessValueScore",
    FEASIBILITY_RATING: "feasibilityScore",
    USE_CASE_CATEGORY: "useCaseCategory",
    ZODIAC_CATEGORY: "zodiacCategory",
  },
  SUGGESTION_ENUM: {
    SUB_INDUSTRY: "subIndustry",
    INDUSTRY: "industry",
    KEYWORD: "keyword",
    TITLE: "title",
  },
  SEARCH_TYPE: {
    ALL: "ALL",
    KEYWORD: "KEYWORD",
    TITLE: "TITLE",
    SUB_INDUSTRY: "SUB_INDUSTRY",
    INDUSTRY: "INDUSTRY",
  },
  HOST: {
    PROD: "tools.pdotools.aws.gartner.com",
    QA: "tools.pdotoolsqa.aws.gartner.com, toolsqa.gartner.com,",
    DEV: "tools.pdotoolsdev.aws.gartner.com, toolsdv.gartner.com, developer.gartner.com",
  },
  URLS: {
    GARTNER: "https://www.gartner.com",
    GARTNER_QA: "https://gcom.pdoqa.aws.gartner.com",
    GARTNER_DEV: "https://gcom.pdodev.aws.gartner.com",
  },
  TOOLS_ENV: {
    PROD: "https://tools.gartner.com",
    QA: "https://toolsqa.gartner.com",
    DEV: "https://toolsdv.gartner.com",
  },
  FILTER_CHIP: {
    USE_CASE_CHIP_CONTENT: {
      ALL: 'All',
      SAVED: 'Added',
      NOT_VIEWED: 'Not Viewed',
    },
    CASE_EXAMPLE_CHIP_CONTENT: {
      ALL: 'All',
      SAVED: 'Saved',
      NOT_VIEWED: 'Not Viewed',
    },
    ALL_KEY: 'ALL',
    SAVED_KEY: 'SAVED',
    NOT_VIEWED_KEY: 'NOT_VIEWED',
  },
  TABS_EMPTY_SECTION: {
    USE_CASES: {
      SAVED: {
        DESC_1: 'No saved use cases found.',
        DESC_2: 'Explore all use cases and save the ones that interest you for easy access later.'
      },
      NOT_VIEWED: {
        DESC_1: 'No unseen use cases left here.',
        DESC_2: 'Switch to <b>All</b> or <b>Added</b> to continue.'
      }
    },
    CASE_EXAMPLES: {
      SAVED: {
        DESC_1: 'No saved Case Examples found.',
        DESC_2: 'Explore all Case Examples and save the ones that interest you for easy access later.'
      },
      NOT_VIEWED: {
        DESC_1: 'No unseen case examples left here.',
        DESC_2: 'Switch to <b>All</b> or <b>Saved</b> to continue.'
      }
    }
  },
  RESULT_SECTION: {
    MAX_LENGTH: 200,
    MAX_ADOPTERS: 99,
    NO_RESULTS_FOUND:
      "No results found for your search. Please consider these suggestions and try again:",
    NO_RESULTS_SUGGESTIONS_ITEM_1: "Double check your spelling.",
    NO_RESULTS_SUGGESTIONS_ITEM_2:
      "Refine your search with different keywords.",
    NO_RESULTS_SUGGESTIONS_ITEM_3: "Browse available",
    VIEWED_TAG: 'Viewed',
    SAVE_MODAL_NOT_OUTSIDE_CLICK_SELECTORS: [
      ".mercury-useCaseSaveIcon--open",
      ".mercury-useCaseSavePopper__scoreCardwrapper--btn",
      ".mercury-useCaseDetailsHeader__info--button",
      ".mercury-useCaseRemoveDialog",
      ".mercury-createOrRenameScorecardModal"
    ],
    IMPLEMENTATION_GUIDE_LOGO: "Includes Implementation Guide",
  },
  ADD_TO_ASSESSMENT: "Add to Assessment",
  ADDED_TO_ASSESSMENT: "Added to Assessment",
  NO_SCORECARD_TEXT: "You don't have any assessments. Create a new assessment to save Use Cases",
  ERROR: {
    COMMON_ERROR_MSG:
      "Sorry, we can't load this right now. Please try again later.",
    TITLE: "Sorry for the inconvenience",
    BODY1: "We're having trouble loading the page you're looking for.",
    BODY2: "Please wait and try again in a few minutes.",
    LABEL: "Refresh Page",
    NEED_HELP: 'Need help?',
    CONTACT_GARTNER_SUPPORT: 'Contact Gartner Technical Support',
    GARTNER_TECH_SUPPORT: '/en/contact/technical-support',
  },
  ACCESS_DENIED_ERROR: {
    TITLE: "Sorry, you don't have permission for this page",
    BODY1:
      "Unfortunately, your current subscription doesn’t allow for you to access this content. Contact your Gartner representative for details on how you can gain access.",
    BODY2: "",
    LABEL: "Go to Gartner Homepage",
  },
  SCORECARD_ACCESS_DENIED_ERROR: {
    TITLE: "You don't have access to this Assessment",
    BODY1: "Sorry, you do not have the necessary permissions to view this assessment.",
    BODY2: "",
    LABEL: "Go to Dashboard",
  },
  PAGE_NOT_FOUND_ERROR: {
    TITLE: "Sorry for the inconvenience",
    BODY1: "We're having trouble finding the page you're looking for.",
    BODY2:
      "Please check the page address to make sure it's correct or visit the dashboard and explore from there.",
    LABEL: "Go to Dashboard",
  },
  COMMON_ERROR_MESSAGE: "Sorry, we are unable to load results right now.",
  MULTI_DASHBOARD: {
    HEADING_TITLE: "Use Case Assessment Dashboard",
    HEADING_SUBTITLE: "Structured use case comparison frameworks to help you identify which AI use cases are worth pursuing based on value and feasibility.",
    YOUR_ASSESSMENTS_HEADER: "My Assessments",
    DESCRIPTION: "Create a custom assessment by selecting and saving use cases that align with your organization's goals",
    OR_TEXT: "Or",
    LAST_UPDATED: 'Last Updated',
    BY_TEXT: ' by ',
    OWNER: 'Owner',
    CONTRIBUTORS: 'Contributors',
    SAVED_USE_CASES: 'Saved Uses Cases',
    MAX_CONTRIBUTORS: 3,
    NO_VALUE_STATE: '---',
    CREATE_SCORECARD: 'Create New Assessment',
    RENAME_SCORECARD: 'Rename Assessment',
    YOUR_TEAM: 'Your Team',
    DELETE_ACTION: 'Delete Assessment',
    LEAVE_ACTION: 'Leave Assessment',
    SCORECARD_NAME_MAX_CHAR_COUNT: 48,
    SCORECARD_NAME_PLACEHOLDER: 'Enter Name',
    CANCEL_BUTTON: 'Cancel',
    CREATE_BUTTON: 'Create',
    SAVE_BUTTON: 'Save',
    DELETE_BUTTON: 'Delete',
    LEAVE_BUTTON: 'Leave',
    DELETE_DESC: 'Are you sure you want to delete this assessment? This action will permanently remove it for all contributors and cannot be undone.',
    LEAVE_DESC: 'Are you sure you want to leave this assessment? It will still be accessible to the owner and other contributors.',
    DELETE_SCORECARD_SUCCESS_TOASTER: 'Assessment deleted successfully',
    LEAVE_SCORECARD_SUCCESS_TOASTER: 'Assessment removed from your dashboard',
    BACK_TO_SCORECARDS: 'Back to Assessments',
    GARTNER_ASSESSMENTS_TAB: {
      HEADER: "Use Gartner's Assessments",
      DESCRIPTION: "Jump-start your prioritization with a Gartner-curated set of use cases organized by industry or function.",
      PUBLISHED_DATE: "Published Date",
      TOTAL_USE_CASES: "Total Uses Cases",
    },
  },
  YOUR_TEAM_DRAWER: {
    HEADER_TITLE: 'Your Team',
    HEADER_DESC: 'Invite colleagues as Contributors to help manage your use cases and prioritize for your organization',
    PERMISSON_HEADER: 'Two roles: Owner and Contributor.',
    PERMISSON_DESC: 'The entitled client who starts the dashboard is always the Owner and can start the team collaboration.',
    PERMISSION_TABLE: {
      ROLE: 'Role',
      OWNER: 'Owner',
      CONTRIBUTOR: 'Contributor',
      YES: 'Yes',
      HEADINGS: [
        'Must have AI Use Case Insights License',
        'Can edit scores',
        'Can customize weights',
        'Can download artifacts',
        'Can add/remove Use Cases',
        'Invite others to collaborate'
      ]
    },
    SEND_INVITE_NOTES: {
      HEADER: 'Add Invite Notes',
      PLACEHOLDER: 'Enter message',
      ROWS: 5,
      CHAR_COUNT: 200,
    },
    SEND_INVITE_BUTTON: 'Send Invite',
    EMAIL_HEADER: 'Invite contributor(s) via email',
    EMAIL_PLACEHOLDER: 'Enter email address',
    EMAIL_MAX_LIMIT: 30,
    MEMBER_HEADER: 'Current Members',
    SUCCESS_DELETE_TOASTER: ' User deleted successfully',
    INVALID_MEMBER_ERROR_MESSAGE: "Some users are not from your organization or don't have a valid license, please remove them to continue.",
    ALREADY_MEMBER_ERROR_MESSAGE: "This team member is already invited to this assessment",
    SUCCESS_INVITE_TOASTER: "Success! You've shared this assessment with your selected recipient(s).",
  },
  SCORECARD: {
    DASHBOARD_LINK: "Assessments",
    HOW_SCORING_WORKS: "How Scoring Works?",
    HOW_SCORING_WORKS_LINK: "https://intercom.help/use-case-insights/en/articles/10649674-how-scoring-works",
    SAVED_USE_CASES: "Saved Use Cases",
    CUSTOMIZE_WEIGHTS: "Customize Weights",
    FILTTER_SCORECARD: "Filter Assessment",
    ADD_MORE_USE_CASE: "Add More Use Cases",
    MANAGE_CTA: 'Manage',
    DOWNLOAD: "Download",
    DOWNLOAD_AS_EXCEL: "Download Assessment toolkit",
    DOWNLOAD_AS_PPT: "Download Assessment PPT",
    TEAM: 'Team',
    USE_CASES: "Use Cases",
    REVENUE: "Revenue",
    EFFICIENCY: "Efficiency",
    RISK_MANAGEMENT: "Managed Risk",
    NON_FINANCIAL: "Non-Financial",
    TECHNICAL: "Technical",
    INTERNAL_READINESS: "Internal Readiness",
    EXTERNAL_READINESS: "External Readiness",
    ADD_TO_GRAPH: "Add to Graph",
    EDIT: "Edit Scores",
    EDITED: "Edited on",
    ADDED_ON: "Added on",
    USE_CASE_EDITED: "Your use case has been edited",
    SAVE_CTA: "Save",
    CANCEL_CTA: "Cancel",
    ADDED: "Added",
    USE_CASE_ADD_TO_GRAPH: "Use Case has been added to the graph",
    REMOVED: "Removed",
    USE_CASE_REMOVED_FROM_GRAPH: "Use Case has been removed from the graph",
    EXPORT_FILE_NAME: "User Case Insights Export.csv",
    OVERALL: "Overall",
    EDIT_DROPDOWN_OPTIONS: ["High", "Medium", "Low", "None"],
    LIKELY_WINS: "Likely Wins",
    CALCULATED_RISK: "Calculated Risk",
    MARGINAL_GAINS: "Marginal Gains",
    CATEGORY_CLASS_MAP: {
      "Likely Wins": "likelyWins",
      "Marginal Gains": "marginalGains",
      "Calculated Risk": "calculatedRisk",
      "Unassessed": "unassessed"
    },
    CATEGORY_TOOLTIP_MAP: {
      "Likely Wins": "Likely Wins offers medium-to-high feasibility with medium-to-high value, making them wins in most circumstances",
      "Marginal Gains": "Marginal Gains offers low value and variable feasibility, making them more-selective options",
      "Calculated Risk": "Calculated Risks offers medium-to-high value but low feasibility, meaning they represent riskier options",
    },
    DISCLAIMER_TEXT: "Note : Dimensions and their weights may differ depending on the industry or business function of the Use Case.",
    COMPARISON_HEADING: "Comparison of Use Cases",
    USE_CASE_ASSESSMENT_HEADING: "Use Case Assessment",
    SHOW_LABELS: "Show Labels",
    LEARN_MORE: "Learn more",
    SAVE_REMOVE_SCORECARD_CONFLICT_MESSAGE: 'This use case was just saved by another user. Please refresh to see the latest status.',
    BACK_TO_SCORECARD: 'Back to Assessment',
    CUSTOMIZE_WEIGHTS_BANNER: 'Custom weights have been applied to the assessment dimensions.',
    VIEW_WEIGHTS_CTA: 'View Weights',
    DISMISS_CTA: 'Dismiss',
    SCORECARD_TABLE_HEADER_TEXT: 'Use Case Scorecard',
    DEFAULT_SCORING_BREAKDOWN_TEXT: 'Scoring Breakdown of Gartner Use Cases',
    FEASIBILITY: 'Feasibility',
    VALUE: 'Value',
    VIEW_USE_CASE: "View Details",
    CUSTOM_UNASSESSED_BANNER_TEXT: "Unassessed use case don't appear on graph. Update scores to see them plotted",
    GRAPH_LEGENDS: {
      GARTNER: 'Gartner',
      CUSTOM: 'My Use Case',
    },
    ADD_USE_CASES_CTA: "Add Use Cases",
    ADD_FROM_LIBRARY_OPTION: "Add from Library",
    NO_USE_CASES_TO_PLOT: {
      HEADER: "No Use Cases to Display",
      DESC: 'Use cases must be assessed and marked with "Add to Graph" to appear on the graph.'
    }
  },
  CUSTOM_USE_CASE_DETAILS_DRAWER: {
    EDIT_DETAILS: "Edit Details",
    DELETE: "Delete",
    UNDO: "Undo",
    EDIT_USE_CASE: {
      HEADER: "Edit Use Case",
      TITLE: {
        LABEL: "Use Case Name",
        PLACEHOLDER: "Enter Name",
        MAX_LIMIT: 35,
        ROWS: 1
      },
      DESCRIPTION: {
        LABEL: "Description",
        PLACEHOLDER: "Enter Description",
        MAX_LIMIT: 500,
        ROWS: 4
      },
      DROPDOWN_PLACEHOLDER: "Select One",
      BACK_CTA: "Back",
      SAVE_CTA: "Save",
    },
    DELETE_SUCCESS_TOASTER: " has been deleted from ",
  },
  EMPTY_ASSESSMENT_CARD: {
    HEADER: "You don't have any assessment",
    DESCRIPTION: "Start with a blank assessment template and add your own use cases.",
    CREATE_CTA: "Create from Scratch",
  },
  EMPTY_SCORECARD_SCREEN: {
    NO_USE_CASES_TITLE: "Get Started with Your Assessment",
    NO_USE_CASES_DESC:
      "Add use cases to this assessment to compare them based on business value and feasibility.",
    CTAS_DESC: {
      ADD: "Explore and add use cases from our library of use cases.",
      IMPORT: "Import your own use cases and start assessing them instantly.",
    }
  },
  USE_CASE: {
    VIEW_MORE: "View More",
    GRID_VIEW: "Grid",
    LIST_VIEW: "List",
  },
  DASHBOARD: {
    BUSINESS_VALUE: "Business Value",
    FEASIBILITY: "Feasibility",
  },
  USECASE_DETAILS: {
    GARTNER_ASSESSMENT_HEADER: "Gartner's Assessment",
    GARTNER_ASSESSMENT_INTERCOM_LINK_TITLE: 'See how we evaluate Use Cases',
    GARTNER_ASSESSMENT_INTERCOM_LINK: 'https://intercom.help/use-case-insights/en/articles/10095757-how-are-use-cases-evaluated-and-rated-by-gartner',
    VIEW_INSIGHTS: 'View Insights',
    BY_WORD: 'By:',
    MAX_LENGTH: 280,
    READ_MORE: 'Read More',
    READ_LESS: 'Read Less',
    CASE_EXAMPLES: "Case Examples",
    VALUE_RATING: "Value Rating: ",
    FEASIBILITY_RATING: "Feasibility Rating: ",
    RATING_TOOLTIP:
      "Ratings represent Gartner's assessment only of the use case, not of any individual case example.",
    NAVIGATION: {
      DOWNLOAD_BUTTON: "Download",
      SHARE_BUTTON: "Share",
    },
    USE_CASE_CATEGORY: "Use-Case Category",
    INFO: {
      INDUSTRY: "Industry:",
      SUB_INDUSTRY: "Sub-Industry:",
      FUNCTION: "Business Function:",
      SUB_FUNCTION: "Sub-Function:",
      ZODIAC_CATEGORY: "Use-Case Family:",
      SEE_LESS: 'See less',
      SEE_MORE: ' more',
      SEE_LESS_MORE_CTA_WIDTH: 100,
      GAP_BETWEEN_CATEGORIES: 24,
      CATEGORY_ESTIMATED_WIDTH: 200,
    },
    TOASTER_MESSAGE: {
      SAVE_SUCCESS: "Use Case has been added to ",
      REMOVE_SUCCESS: " has been removed from ",
      UNDO_BUTTON: "Undo",
      FAILURE_MESSAGE: "Your request could not be processesed. Please try again.",
      SAVE_MAX_LIMIT_REACHED_MESSAGE_1: "Remove saved use cases",
      SAVE_MAX_LIMIT_REACHED_MESSAGE_2: " to make room for more.",
      VIEW_ASSESSMENT_CTA: "View Assessment"
    },
    ADOPTERS: {
      CASE_EXAMPLES_TITILE: "Associated Case Example",
      CASE_STUDY_DISCLAIMER: "Disclaimer: Gartner does not endorse any company, vendor, product, or service depicted in its publications, and does not advise technology users to select only those vendors with the highest ratings or other designation. Gartner publications consist of the opinions of Gartner's business and technology insights organization and should not be construed as statements of fact. Gartner disclaims all warranties, expressed or implied, with respect to this publication, including any warranties of merchantability or fitness for a particular purpose.",
      GOAL_TEXT: "Goal",
      SOLUTION_TEXT: "Solution",
      RESULT_TEXT: "Result",
      VENDOR_TEXT: "Vendor",
      MARKET_AVAILABILITY_TEXT: "Market Availability",
      DEPLOYMENT_MODEL_TEXT: "Deployment Model",
      KEY_TECHNOLOGIES_TEXT: "Key Technologies",
      CASE_EXAMPLE_SOURCE: "Case Example Source ",
      SOURCE_TEXT_1: "Source :",
      SOURCE_TEXT_2: "Gartner Eye on Innovation",
      ARCHIVED_STATE: 'Archived',
    },
    NA_VALUE: "NA",
    CONTENT: {
      VALUE_TOOLTIP_TITLE: "Value Dimension Explanations",
      FEASIBILITY_TOOLTIP_TITLE: "Feasibility Dimension Explanations",
      VALUE: "Value",
      FEASIBILITY: "Feasibility",
      OVERALL_RATING: "Overall Rating: ",
      BELONGS_TO: "Use Case Category: ",
      LIKELY_WINS: "Likely Wins offers medium-to-high feasibility with medium-to-high value, making them wins in most circumstances",
      CALCULATED_RISK: "Calculated Risks offers medium-to-high value but low feasibility, meaning they represent riskier options",
      MARGINAL_GAINS: "Marginal Gains offers low value and variable feasibility, making them more-selective options",
    },
    RELATED_USE_CASES_HEADER: 'Related Use Cases',
    ZODIAC_CATEGORY_TOOLTIP: {
      HEADER: "Use-Case Family",
      DESCRIPTION: "Use case families are a framework of 12 core function and industry agnostic families that outline relevant AI techniques to guide implementation",
      LEARN_MORE: "Learn More",
      LEARN_MORE_LINK: "https://www.gartner.com/document-reader/document/code/833983?ref=ddisp&refval=833983",
    },
    YOUR_ASSESSMENT_CALLOUT_TEXT: "Added to",
    IMPLEMENTATION_GUIDE: {
      HEADER: "View the Implementation Guide for this Use Case",
      DESCRIPTION: "Step-by-step guidance to implement this use case across planning, pilot, and deployment.",
      BUTTON: "View Full Implementation Guide"
    },
    GARTNER_ASSESSMENTS_INCLUDES_TEXT: "Part of assessment"
  },
  CATEGORY_CHART: {
    MARGIN_TOP: 0,
    MARGIN_RIGHT: 0,
    MARGIN_BOTTOM: 10,
    MARGIN_LEFT: 10,
    WIDTH: chartSquareLength,
    HEIGHT: chartSquareLength,
    MOBILE_WIDTH: 320,
    MOBILE_HEIGHT: 320,
    POPPER_WIDTH: 332,
    NEW_DEFAULT_DOMAIN: [0, 4.4],
    POINT_RADIUS: 12,
    TOP_LEFT_QUADRANT_LABEL: "Calculated Risks",
    BOTTOM_QUADRANT_LABEL: "Marginal Gains",
    TOP_RIGHT_QUADRANT_LABEL: "Likely Wins",
    HIGH: "High",
    LOW: "Low",
    VALUE: "Value",
    FEASIBILITY: "Feasibility",
    LABEL_LENGTH_FOR_TRUNCATION: 30,
    UPPER_QUADRANT_RATIO: 2.66 / 4,
    ASSESSMENT_GRAPH_WIDTH: Math.round(window.innerHeight * 0.8),
    ASSESSMENT_GRAPH_HEIGHT:  Math.round(window.innerHeight * 0.59),
  },
  CATEGORY_CHART_NEW: {
    WIDTH: 280,
    HEIGHT: 280,
    MARGIN_TOP: 25,
    MARGIN_RIGHT: 10,
    MARGIN_BOTTOM: 40,
    MARGIN_LEFT: 25,
    POINT_RADIUS: 6,
    HEADER: 'Use Case Visualization',
    MAX_LABEL_LENGTH_CONDITION: 46,
    MAX_LABEL_LENGTH_VALUE: 41,
  },
  EXTERNAL_ACTIS_UPDATE_REF: {
    HAM_MENU_REF: "HAM-MENU",
    HP_DF_REF: "HP-DF",
    SHORTCUT_NAV_REF: "SHORTCUT-NAV",
    GCOM_SEARCH_POPULAR_REF: "GCOM-SEARCH-POPULAR",
    MY_TOOLS_REF: "MY-TOOLS",
    AI_MICROSITE_REF: "AI-MICROSITE",
    TOOL_WRAPPER_REF: "TOOL-WRAPPER",
    SHARE_EMAIL_REF: "SHARE-EMAIL",
    SHARE_SCORECARD_REF: "SHARE-SCORECARD",
  },
  ACTIS: {
    CURRENT_PAGE: {
      LANDING: "Discovery Page",
      USECASE_DETAILS: "Use Case Details Page",
      DASHBOARD: "Dashboard Page",
      SCORECARD: "Scorecard Page",
    },
    CURRENT_PAGE_REPLACE: "##CURRENT_PAGE##",
    USE_CASE_TITLE_REPLACE: "##USE_CASE_TITLE##",
    USE_CASE_ID_REPLACE: "##USE_CASE_ID##",
    SCORECARD_ID_REPLACE: "##SCORECARD_ID##",
    CASE_STUDY_TITLE_REPLACE: "##CASE_STUDY_TITLE##",
    CASE_STUDY_ID_REPLACE: "##CASE_STUDY_ID##",
    USE_CASE_CARD_VALUE: "- Use Case Card",
    USE_CASE_DETAILS_PAGE_VALUE: "on Use Case details page",
    LOGIN: {
      ACTION: "User logged into the application",
      LABEL: "##CURRENT_PAGE##",
    },
    EXTERNAL_ACTIS: {
      "ham-menu": {
        ACTION: "User navigates from hamburger on Gcom Homepage",
        LABEL: "Gcom Homepage",
      },
      "hp-df": {
        ACTION: "User navigates from Promo card on Gcom Homepage",
        LABEL: "Gcom Homepage",
      },
      "shortcut-nav": {
        ACTION: "User navigates from hamburger on Gcom Apptray",
        LABEL: "Gcom Homepage",
      },
      "gcom-search-popular": {
        ACTION: "User navigates from hamburger on Gcom Popular Panel",
        LABEL: "Gcom Homepage",
      },
      "my-tools": {
        ACTION: "User navigates from hamburger on MyTools",
        LABEL: "Gcom Homepage",
      },
      "ai-microsite": {
        ACTION: "User navigates from AI Microsite",
        LABEL: "Gcom Homepage",
      },
      "tool-wrapper": {
        ACTION: "User navigates from AI UCI Tool Wrapper",
        LABEL: "Tool Wrapper",
      },
      "share-email": {
        ACTION: 'User clicked on "View Use Cases" on Email',
        LABEL: "##CURRENT_PAGE## | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
      },
      "share-scorecard": {
        ACTION: 'Email - View Scorecard CTA',
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
    },
    HOME_BREADCRUMBS: {
      ACTION: "User Clicked on 'Home' from breadcrumbs",
      LABEL: "##CURRENT_PAGE##",
    },
    WHATS_NEXT: {
      ACTION: "User clicks on ##CURRENT_LINK##",
      LABEL: "##CURRENT_PAGE##",
      CURRENT_LINK: '##CURRENT_LINK##'
    },
    EXPERT_ENQUIRY: {
      ACTION: "User clicks on Connect with Gartner Experts",
      USE_CASE_LABEL: "Use Case Details Page | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
      DASHBOARD_LABEL: "Scorecard Page | ##SCORECARD_ID##",
    },
    SAVE_DROPDOWN_OPEN: {
      ACTION: "Event for opening modal, not for clicking on 'Add'",
      LABEL: "##CURRENT_PAGE## | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
    },
    ADD_TO_ASSESSMENT: {
      DROPDOWN_OPEN: {
        ACTION: "User opens modal for Add to Assessment on ##CURRENT_PAGE##",
        LABEL: "##CURRENT_PAGE##",
      },
      ADDED_SCORECARD: {
        ACTION: "User adds to scorecard on ##CURRENT_PAGE##",
        LABEL: "##CURRENT_PAGE## | ##SCORECARD_ID##",
      },
      CREATE_NEW_ASSESSMENT: {
        ACTION: "User clicks 'create' on Assessment_##CURRENT_PAGE##",
        LABEL: "##CURRENT_PAGE## | ##SCORECARD_ID##",
      }
    },
    LANDING_PAGE: {
      SEARCH: {
        ACTION: "User inputed keyword on Search",
        LABEL: "Discovery Page | ##SEARCH_TERM##",
        SEARCH_TERM: "##SEARCH_TERM##",
      },
      FILTER: {
        ACTION: "User applied ##FILTER_TYPE## filter on landing page",
        LABEL:
          "Discovery Page | ##FILTER_VALUE## ",
        FILTER_TYPE: "##FILTER_TYPE##",
        FILTER_VALUE: "##FILTER_VALUE##",
      },
      CARDS: {
        ACTION: "User clicked on Use Case tile",
        LABEL: "Discovery Page | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
      },
      SAVE_USECASE: {
        ACTION: "User Saved a Use Case to their scorecard",
        LABEL: "Discovery Page | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
      },
      UNSAVE_USECASE: {
        ACTION: "User clicked on 'remove' from save modal dropdown",
        LABEL: "Discovery Page | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
      },
      VIEW_MORE_USECASES: {
        ACTION: "User clicked View More on Discovery Page",
        LABEL: "Discovery Page",
      },
      FILTER_CHIPS: {
        CURRENT_ACTION: '##CURRENT_ACTION##',
        ACTION: "User clicks on '##CURRENT_ACTION##' tab",
        LABEL: "Discovery Page",
      },
      TOGGLE_VIEW: {
        CURRENT_VIEW: '##CURRENT_VIEW##',
        ACTION: "User Clicks on ##CURRENT_VIEW## View",
        LABEL: "Discovery Page",
      }
    },
    USE_CASE_DETAILS: {
      SAVE_USECASE: {
        ACTION: "User Saved a Use Case to their scorecard",
        LABEL: "Use Case Details Page | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
      },
      UNSAVE_USECASE: {
        ACTION: "User clicked on 'remove' from save modal dropdown",
        LABEL: "Use Case Details Page | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
      },
      DOWNLOAD_USE_CASE: {
        ACTION: 'User clicked Download PPT on Use Case details page',
        LABEL: 'Use Case Details Page | ##USE_CASE_TITLE## | ##USE_CASE_ID##'
      },
      GARTNER_ASSESSMENT_EXPLAINED: {
        ACTION: "User clicks on right hand panel for Gartner's Assessment Explained",
        LABEL: "Use Case Details Page | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
      },
      CASE_STUDY_SOURCE: {
        ACTION: "User clicks on Case Study Source ##CASE_STUDY_SOURCE_ID##",
        LABEL: "Use Case Details Page | ##USE_CASE_TITLE## | ##CASE_STUDY_TITLE## | ##USE_CASE_ID## | ##CASE_STUDY_ID##",
        CASE_STUDY_SOURCE_ID: "##CASE_STUDY_SOURCE_ID##",
      },
      TOOLTIP_DEFINATIONS: {
        ACTION: "User clicked on '##CURRENT_TOOLTIP##' tooltip definitions",
        CURRENT_TOOLTIP: "##CURRENT_TOOLTIP##",
        LABEL: "Use Case Details Page | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
      },
      SHARE_CTA: {
        ACTION: "User clicked on Share CTA - Use Case Details ##CURRENT_SECTION##",
        CURRENT_SECTION: "##CURRENT_SECTION##",
        LABEL: "Use Case Details Page | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
        MODAL: "Modal",
        PAGE: "Page",
      },
      ANALYST_NAME: {
        ACTION: "User Clicks on Analyst Name on Use Case Details Page",
        LABEL: "Use Case Details Page | ##USE_CASE_TITLE## | ##USE_CASE_ID## | ##NAME_PLACEHOLDER##",
        NAME_PLACEHOLDER: "##NAME_PLACEHOLDER##",
      },
      RESEARCH_URL: {
        ACTION: "User Clicks on Research URL on Use Case Details Page",
        LABEL: "Use Case Details Page | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
      },
      PAGE_LOAD: {
        ACTION: "Use Case Details Page Load",
        LABEL: "Use Case Details Page | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
      },
      CASE_EXAMPLES: {
        ACTION: "User ##ACCORDION_STATE## accordion for a case study",
        LABEL: "Use Case Details Page | ##USE_CASE_TITLE## | ##CASE_STUDY_TITLE## | ##USE_CASE_ID## | ##CASE_STUDY_ID##",
        ACCORDION_STATE: "##ACCORDION_STATE##",
        OPEN: "opens",
        CLOSE: "closes",
      },
      RELATED_USE_CASES: {
        ACTION: "User clicks on a related use case from Use Case Detail Page",
        LABEL: "Use Case Details Page | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
      },
      ASSESSMENT_CALLOUT: {
        ACTION: "User clicks on assessment callout on Use Case details page",
        LABEL: "Use Case Details Page | ##USE_CASE_TITLE## | ##USE_CASE_ID## | ##SCORECARD_ID##",
      }
    },
    DASHBOARD: {
      SCORECARD_CLICK: {
        ACTION: "User enters a scorecard via the dashboard page",
        LABEL: "Dashboard Page",
      },
      ELLIPSIS: {
        YOUR_TEAM: {
          ACTION: "User clicks on Your team CTA on dashboard",
          LABEL: "Dashboard Page",
        },
        RENAME_SCORECARD: {
          ACTION: "User clicks on Rename CTA on dashboard",
          LABEL: "Dashboard Page",
        },
        DELETE_SCORECARD: {
          ACTION: "User Clicks on 'Delete Scorecard'",
          LABEL: "Dashboard Page | ##SCORECARD_ID##",
        },
        LEAVE_SCORECARD: {
          ACTION: "User Clicks on 'Leave Scorecard'",
          LABEL: "Dashboard Page | ##SCORECARD_ID##",
        }
      },
      CREATE_NEW_SCORECARD: {
        CTA: {
          ACTION: "User clicks on Create New Scorecard",
          LABEL: "Dashboard Page",
        },
        CREATE_CTA: {
          ACTION: "User clicks on Create on New Scorecard",
          LABEL: "Dashboard Page",
        },
        CANCEL_CTA: {
          ACTION: "User clicks on Cancel on New Scorecard",
          LABEL: "Dashboard Page",
        },
        SAVE_MODAL: {
          ACTION: "User Clicks on 'Create New Scorecard' on save modal",
          LABEL: "##CURRENT_PAGE## | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
        }
      },
      ASSESSMENT_CHIP_CLICK: {
        ACTION: "User Clicks on ##SELECTED_CHIP## on dashboard",
        LABEL: "Dashboard Page",
        SELECTED_CHIP: "##SELECTED_CHIP##"
      },
      GARTNER_ASSESSMENT_DROPDOWN: {
        ACTION: "User Clicks on Gartner's Assessment- Industry/Function dropdown",
        LABEL: "Dashboard Page | Industry/Function: ##IND_FUN_VALUE##",
        IND_FUN_VALUE: "##IND_FUN_VALUE##",
      },
      GARTNER_ASSESSMENT_CLICK: {
        ACTION: "User clicks on Gartner Assessment",
        LABEL: "Dashboard Page | ##SCORECARD_ID##",
      },
      ASSESSMENTS_DROPDOWN_CLEAR_SELECTION: {
        ACTION: "User clicks on Clear Selection on Dashboard Page",
        LABEL: "Dashboard Page",
      },
    },
    SCORECARD: {
      MANAGE_CTA: {
        ACTION: "User clicks on Edit within a scorecard",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
      ADD_MORE_CTA: {
        ACTION: 'User clicks on "Add More Use Cases" within a scorecard',
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
      RENAME_SCORECARD_CTA: {
        ACTION: 'User clicks on Rename scorecard',
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
      FILTER_SCORECARD_CTA: {
        ACTION: 'User Clicks on Scorecard filter under Manage',
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
      DOWNLOAD_EXCEL: {
        ACTION: "User clicked on download",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
      DOWNLOAD_PPT: {
        ACTION: "User clicked on scorecard download .ppt",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
      GRAPH_LEARN_MORE: {
        ACTION: "User clicks on Learn More",
        LABEL: "Scorecard Page | ##USE_CASE_TITLE## | ##USE_CASE_ID## | ##SCORECARD_ID##",
      },
      SCORE_CARD_PAGINATION: {
        ACTION: "User clicks on pagination ##PAGINATION_KEY##",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
        PAGINATION_KEY: "##PAGINATION_KEY##",
      },
      BROWSE_USE_CASES: {
        ACTION: "User clicks on Browse Use Cases",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
      CUSTOMIZE_WEIGHTS_CTA: {
        ACTION: "User Clicks on Customize Weights on scorecard",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
      VIEW_WEIGHTS_CTA: {
        ACTION: "User clicks on 'View Weights' on custom weights callout",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
      DISMISS_CTA: {
        ACTION: "User clicks on 'dismiss' on custom weights callout",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
      HOW_SCORING_WORKS: {
        ACTION: "User Clicks on How Scoring Works link",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
      CATEGORY_TOOLTIP: {
        ACTION: "User views tooltip of Use Case Category",
        LABEL: "Scorecard Page | ##USE_CASE_TITLE## | ##USE_CASE_ID## | ##SCORECARD_ID##",
      },
      ADD_TO_GRAPH_CHECKBOX: {
        ACTION: "User ##ADD_TO_GRAPH_ACTION## add to graph CTA",
        LABEL: "Scorecard Page | ##USE_CASE_TITLE## | ##USE_CASE_ID## | ##SCORECARD_ID##",
        ADD_TO_GRAPH_ACTION: "##ADD_TO_GRAPH_ACTION##",
        ADDED_TO: "added to",
        REMOVED_FROM: "removed from",
        CHECKS: "checks",
        UNCHECKS: "unchecks",
      },
      EDIT_ICON: {
        ACTION: "User clicks on edit icon",
        LABEL: "Scorecard Page | ##USE_CASE_TITLE## | ##USE_CASE_ID## | ##SCORECARD_ID##",
      },
      EDIT_DROPDOWN_OPTIONS: {
        ACTION: "User changes ##CHANGED_OPTION## parameter",
        LABEL: "Scorecard Page | ##USE_CASE_TITLE## | ##USE_CASE_ID## | ##SCORECARD_ID##",
        CHANGED_OPTION: "##CHANGED_OPTION##"
      },
      EDIT_SAVE_CTA: {
        ACTION: "User clicks on Save after editing Use Case scores",
        LABEL: "Scorecard Page | ##USE_CASE_TITLE## | ##USE_CASE_ID## | ##SCORECARD_ID##",
      },
      EDIT_CANCEL_CTA: {
        ACTION: "User clicks on Cancel after editing Use Case scores",
        LABEL: "Scorecard Page | ##USE_CASE_TITLE## | ##USE_CASE_ID## | ##SCORECARD_ID##",
      },
      USE_CASE_NAME_LINK: {
        ACTION: "User clicks on hyperlink for right hand panel",
        LABEL: "Scorecard Page | ##USE_CASE_TITLE## | ##USE_CASE_ID## | ##SCORECARD_ID##",
      },
      GRAPH: {
        ACTION: "User hovered on Use Case dot",
        LABEL: "Scorecard Page | ##USE_CASE_TITLE## | ##USE_CASE_ID## | ##SCORECARD_ID##",
      },
      SCORING_BREAKDOWN: {
        ACTION: "User views scoring breakdown on scorecard",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
      GARTNER_ASSESSMENT_DETAILS_VIEW_INSIGHTS: {
        ACTION: "User clicks on View Insights on Gartner Assessment",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
      GARTNER_ASSESSMENT_DETAILS_ANALYST_CLICK: {
        ACTION: "User clicks on analyst name on Gartner Assessment",
        LABEL: "Scorecard Page | ##SCORECARD_ID## | ##NAME_PLACEHOLDER##",
        NAME_PLACEHOLDER: "##NAME_PLACEHOLDER##",
      },
      GARTNER_ASSESSMENT_DOWNLOAD_PPT: {
        ACTION: "User downloads Gartner Assessment .ppt",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
      GARTNER_ASSESSMENT_PAGE_LOAD: {
        ACTION: "Page load for Gartner Assessment",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
      GRAPH_SHOW_HIDE_LABELS: {
        ACTION: "User ##CURRENT_STATE## 'Show labels'",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
        CURRENT_STATE_REPLACE: "##CURRENT_STATE##",
        CHECKS: "checks",
        UNCHECKS: 'unchecks',
        SHOW: "Show",
        HIDE: "Hide",
      },
      GRAPH_DOT_CLICK: {
        ACTION: "User clicks on a Use Case dot in graph",
        LABEL: "Scorecard Page | ##USE_CASE_TITLE## | ##USE_CASE_ID## | ##SCORECARD_ID##",
      },
      GRAPH_VIEW_DETAILS_CTA : {
        ACTION: "User clicks on View details after clicking on Use Case dot",
        LABEL: "Scorecard Page | ##USE_CASE_TITLE## | ##USE_CASE_ID## | ##SCORECARD_ID##",
      },
      IMPORT_USE_CASES_CTA: {
        ACTION: "User clicks on Import Use Cases",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
    },
    RENAME_SCORECARD: {
      SAVE_CTA: {
        ACTION: 'User clicks on Rename scorecard - Save on Modal',
        LABEL: "##CURRENT_PAGE##",
      },
      CANCEL_CTA: {
        ACTION: 'User clicks on Rename scorecard - Cancel on Modal',
        LABEL: "##CURRENT_PAGE##",
      },
    },
    FILTER_SCORECARD: {
      APPLY_CTA: {
        ACTION: 'User Clicks on Apply on Scorecard filter',
        LABEL: "Scorecard Page | ##APPLIED_FILTERS## | ##SCORECARD_ID##",
        APPLIED_FILTERS_REPLACE: '##APPLIED_FILTERS##',
      },
      CLEAR_CTA: {
        ACTION: 'User Clicks on clear filter on Scorecard filter',
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
    },
    YOUR_TEAM_DRAWER: {
      SEND_INVITE: {
        ACTION: 'User Clicks on Send Invite on ##CURRENT_PAGE##',
        LABEL: "##CURRENT_PAGE## | ##SCORECARD_ID##",
      },
      DELETE_REMOVE: {
        ACTION: 'User clicks on Remove User from Delete Icon',
        LABEL: "##CURRENT_PAGE##",
      },
      DELETE_CANCEL: {
        ACTION: 'User clicks on Cancel from Delete Icon',
        LABEL: "##CURRENT_PAGE##",
      },
      ROLES_PERMISSIONS: {
        ACTION: 'Learn About Roles and Permisssions',
        LABEL: "##CURRENT_PAGE##",
      },
    },
    USE_CASE_DETAILS_SIDE_DRAWER: {
      BACK_TO_SCORECARD: {
        ACTION: "User clicks on back to scorecard",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
      VIEW_MORE_DETAILS: {
        ACTION: "User clicks on View Use Case details",
        LABEL: "Scorecard Page | ##USE_CASE_TITLE## | ##USE_CASE_ID## | ##SCORECARD_ID##",
      },
      SAVE_UNSAVE_USECASE: {
        ACTION: "User clicks on ###SAVE_UNSAVE_PLACEHOLDER### on right hand panel",
        LABEL: "Scorecard Page | ##USE_CASE_TITLE## | ##USE_CASE_ID## | ##SCORECARD_ID##",
        SAVE_UNSAVE_PLACEHOLDER: '###SAVE_UNSAVE_PLACEHOLDER###',
        SAVE: 'save',
        UNSAVE: 'unsave',
      },
    },
    CUSTOMIZE_WEIGHTS: {
      BACK_TO_SCORECARD_CTA: {
        ACTION: "User Clicks on Customize Weights - Back to Scorecard",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      },
      SAVE_PARAMETER_CTA: {
        ACTION: "User Clicks on Save Paramater Weights : Overall",
        LABEL: "Scorecard Page | Overall | ##SCORECARD_ID##",
      },
      RESET_TO_DEFAULT_CTA: {
        ACTION: "User clicks on reset to default",
        LABEL: "Scorecard Page | ##SCORECARD_ID##",
      }
    },
    SUCCESS_TOASTER: {
      ACTION: "User clicked on Dashboard link on toaster message on saving",
      LABEL: "##CURRENT_PAGE## | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
    },
    UNDO_TOASTER: {
      ACTION: "User clicked on Undo link to save usecase",
      LABEL: "##CURRENT_PAGE## | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
    },
    MAX_LIMIT_SUCCESS_TOASTER: {
      ACTION: 'Toaster message of save use case limit reached.',
      LABEL: '##CURRENT_PAGE##',
    },
    SIDE_PANEL: {
      HOME: {
        ACTION: "User clicked on Home from left hand panel",
        LABEL: "Left hand Panel",
        VALUE: "Home",
      },
      DASHBOARD: {
        ACTION: "User clicked on Dashboard from left hand panel",
        LABEL: "Left hand Panel",
        VALUE: "Dashboard",
      },
    },
    INTERCOM: {
      ACTION: "Dialog box ##DIALOG_PARAM##",
      LABEL: "All",
      DIALOG_PARAM: "##DIALOG_PARAM##",
      SHOW_VALUE: 'show',
      HIDE_VALUE: 'hide',
    },
    TABS_NAVIGATION: {
      ACTION: "User clicks on ##ACTIVE_TAB## Tab",
      LABEL: "Navigation Tabs",
      ACTIVE_TAB: "##ACTIVE_TAB##",
    },
    CASE_EXAMPLES: {
      SEARCH: {
        ACTION: "User inputed keyword on Search for Case Examples",
        LABEL: "Case Examples Page | ##SEARCH_TERM##",
        SEARCH_TERM: "##SEARCH_TERM##",
      },
      FILTER: {
        ACTION: "User clicks on ##FILTER_TYPE## filter in Case Examples Tab",
        LABEL: "Case Examples Page | ##FILTER_VALUE## ",
        FILTER_TYPE: "##FILTER_TYPE##",
        FILTER_VALUE: "##FILTER_VALUE##",
      },
      CHIPS: {
        CURRENT_CHIP: '##CURRENT_CHIP##',
        ACTION: "User clicks on ##CURRENT_CHIP## Case Examples tab",
        LABEL: "Case Examples Page",
      },
      VIEW_MORE: {
        ACTION: "View More on Case Examples",
        LABEL: "Case Examples Page",
      },
      SAVE_UNSAVE_CTA: {
        ACTION: "##CURRENT_ACTION## on Case Example Page library",
        LABEL: "Case Examples Page | ##CASE_STUDY_TITLE## | ##CASE_STUDY_ID##",
        CURRENT_ACTION: "##CURRENT_ACTION##",
        SAVE: 'Save',
        UNSAVE: 'Unsave',
      },
      NO_RESULTS_CTA: {
        ACTION: "Browse available Case Examples - blank search query",
        LABEL: "Case Examples Page",
      }
    },
    CASE_EXAMPLES_DETAILS: {
      SAVE_UNSAVE_CTA: {
        ACTION: "##CURRENT_ACTION## on Case Example Details Page",
        LABEL: "Case Examples Detail Page | ##CASE_STUDY_TITLE## | ##CASE_STUDY_ID##",
        CURRENT_ACTION: "##CURRENT_ACTION##",
        SAVE: 'Save',
        UNSAVE: 'Unsave',
      },
      PAGE_LOAD: {
        ACTION: "Page Load for Case Example Details page",
        LABEL: "Case Examples Detail Page | ##CASE_STUDY_TITLE## | ##CASE_STUDY_ID##",
      },
      DOWNLOAD_PPT: {
        ACTION: "Download Case Example .ppt",
        LABEL: "Case Examples Detail Page | ##CASE_STUDY_TITLE## | ##CASE_STUDY_ID##",
      },
      SHARE_CTA: {
        ACTION: "Open share modal on Case Example details page",
        LABEL: "Case Examples Detail Page | ##CASE_STUDY_TITLE## | ##CASE_STUDY_ID##",
      },
      SHARE: {
        ACTION: "Share on Case Example details page",
        LABEL: "Case Examples Detail Page | ##CASE_STUDY_TITLE## | ##CASE_STUDY_ID##",
      }
    },
    HOME_PAGE: {
      FEATURED_USE_CASES_CARD_CLICK: {
        ACTION: "User clicks on one of the featured Use Cases",
        LABEL: "Homepage | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
      },
      FEATURED_USE_CASES_VIEW_ALL: {
        ACTION: "User clicks on View All for Featured Use Cases",
        LABEL: "Homepage",
      },
      ASSESSMENTS_RADIO_TOGGLE: {
        ACTION: "User clicks on Industry/Function toggle",
        LABEL: "Homepage | ##IND_FUN_TOGGLE##",
        IND_FUN_TOGGLE: "##IND_FUN_TOGGLE##",
      },
      ASSESSMENTS_IND_FUN_DROPDOWN: {
        ACTION: "User selects Industry or Function from dropdown",
        LABEL: "Homepage | Industry/Function: ##IND_FUN_VALUE##",
        IND_FUN_VALUE: "##IND_FUN_VALUE##",
      },
      ASSESSMENTS_ASSESSNENT_DROPDOWN: {
        ACTION: "User selects Assessment Name from dropdown",
        LABEL: "Homepage | ##SCORECARD_ID##",
      },
      ASSESSMENTS_CLEAR_SELECTION: {
        ACTION: "User clicks on Clear Selection on Assessments Home Page",
        LABEL: "Homepage",
      },
      ASSESSMENTS_VIEW_ASSESSMENT: {
        ACTION: "User clicks on View Assessment CTA on Homepage",
        LABEL: "Homepage | ##SCORECARD_ID##",
      },
      ASSESSMENTS_TOOGLETIP: {
        ACTION: "Toggletip for Gartner Assessment Section",
        LABEL: "Homepage",
      },
      GO_TO_ASSESSMENTS: {
        ACTION: "User clicks on new banner for assessments on HomePage",
        LABEL: "Homepage",
      },
      FEATURED_CASE_EXAMPLES_CARD_CLICK: {
        ACTION: "User clicks on one of the featured Case Examples",
        LABEL: "Homepage | ##CASE_STUDY_TITLE## | ##CASE_STUDY_ID##",
      },
      FEATURED_CASE_EXAMPLES_VIEW_ALL: {
        ACTION: "User clicks on View All for Featured Case Examples",
        LABEL: "Homepage",
      },
    },
    IMPORT_USE_CASES: {
      KEEP_YOUR_USE_CASE_CTA: {
        ACTION: "User clicks on Keep your use case",
        LABEL: "Import | ##SCORECARD_ID## | ##USE_CASE_TITLE##",
      },
      REPLACE_WITH_GARTNER_CTA: {
        ACTION: "User clicks on Replace with Gartner",
        LABEL: "Import | ##SCORECARD_ID## | ##USE_CASE_TITLE## | ##USE_CASE_ID##",
      },
      FINISH_AND_SCORE_CTA: {
        ACTION: "User clicks on Finish or Finish & Score Later",
        LABEL: "Import | ##SCORECARD_ID##",
      },
    }
  },
  PPT: {
    DOWNLOAD_FILE_NAME: 'Use Case Insights',
    DISCLAIMER: {
      HEADER: "Disclaimers",
      LINE_1: "Objectivity Disclaimer",
      LINE_2: "Gartner does not endorse any company, vendor, product, or service depicted in its publications, and does not advise technology users to select only those vendors with the highest ratings or other designation. Gartner publications consist of the opinions of Gartner's business and technology insights organization and should not be construed as statements of fact. Gartner disclaims all warranties, expressed or implied, with respect to this publication, including any warranties of merchantability or fitness for a particular purpose.",
      LINE_3: "\nConfidentiality and Intellectual Property",
      LINE_4:
        `These materials have been prepared by Gartner Inc. and/or its affiliates ("Gartner") for the exclusive and individual use of our clients. These materials contain valuable confidential and proprietary information belonging to Gartner, and they may not be shared with any third party (including independent contractors and consultants) without the prior approval of Gartner. Gartner retains any and all intellectual property rights in these materials and requires retention of the copyright mark on all pages reproduced.`,
      LINE_5: "\nLegal Caveat",
      LINE_6:
        "Gartner is not able to guarantee the accuracy of the information or analysis contained in these materials. Furthermore, Gartner is not engaged in rendering legal, accounting, or any other professional services. Gartner specifically disclaims liability for any damages, claims, or losses that may arise from a) any errors or omissions in these materials, whether caused by Gartner or its sources, or reliance upon any recommendation made by Gartner.",
      LINE_7: "\nDisclaimer",
      LINE_8:
       "Unless otherwise set forth in your Service Description or marked expressly for external use, these items may be downloaded and customized for internal noncommercial use by the Client. The items contained in this report may not be repackaged or resold. Gartner makes no representations or warranties as to the suitability of this report for any particular purpose, and disclaims all liability for any damage or loss, whether direct, consequential, incidental or special, arising out of the use of or inability to use this material or the information provided herein.",
    },
    SCORECARD: {
      TITLE: "AI Use Case Insights",
      SUB_TITLE: "Use-Case Assessment:",
      SCORECARD_SUMMARY_TITLE: "Assessment Summary",
      TITLE_DASHBOARD: "Use Case Insights Dashboard",
      SCORECARD_GRAPH_TITLE: "AI Use-Case Assessment for",
      SCORECARD_TABLE_HEADER: "Use-Case Scorecard",
      SCORECARD_TABLE_PARAMS_NOTE: "Note 1: Parameters may differ depending on the industry or business function of the Use Case",
      SCORECARD_TABLE_CUSTOM_WEIGHTS_NOTE: "Note 2: Custom weights are applied for all Use Cases",
      SCORECARD_TABLE_DEFAULT_WEIGHTS_NOTE: "Note 2: Gartner Default Weights are applied for all Use Cases",
      USECASE_SUMMARY_TITLE: "Use Case Details",
      USECASE_SUMMARY_SUB_TITLE: "Use Cases in Assessment - "
    },
    SCORECARD_TABLE_CELL_BORDER: [
      { color: "000000", pt: 1 },
      { type: "solid", color: "000000", pt: 2 },
      { color: "000000", pt: 1 },
      { color: "000000", pt: 1 }
    ],
    SCORECARD_TABLE: [
      [
        { text: "", options: { colspan: 1, align: "center", color: 'ffffff', fill: '002856' } },
        { text: "", options: { colspan: 1, align: "center", color: 'ffffff', fill: '002856' } },
        { text: "", options: { colspan: 1, align: "center", color: 'ffffff', fill: '002856' } },
        { text: "", options: { colspan: 1, align: "center", color: 'ffffff', fill: '002856' } },
        { text: "Business Value", options: { colspan: 5, align: "center", bold: true, color: 'ffffff', fill: '002856' } },
        { text: "Feasibility", options: { colspan: 4, align: "center", bold: true, color: 'ffffff', fill: '002856' } },
      ],
      [
        { text: "Industry", options: { colspan: 1, align: "center", bold: true, fill: '2e568d', color: 'ffffff' } },
        { text: "Sub-Industry", options: { colspan: 1, align: "center", bold: true, fill: '2e568d', color: 'ffffff' } },
        { text: "Business Function", options: { colspan: 1, align: "center", bold: true, fill: '2e568d', color: 'ffffff' } },
        { text: "Use Case Name", options: { colspan: 1, align: "center", bold: true, fill: '2e568d', color: 'ffffff', border: [{ color: "000000", pt: 1 }, { type: "solid", color: "000000", pt: 2 }, { color: "000000", pt: 1 }, { color: "000000", pt: 1 }] } },
        { text: "Increase Revenue", options: { colspan: 1, align: "center", bold: true, fill: '2e568d', color: 'ffffff' } },
        { text: "Increase Efficiency", options: { colspan: 1, align: "center", bold: true, fill: '2e568d', color: 'ffffff' } },
        { text: "Manage Risk", options: { colspan: 1, align: "center", bold: true, fill: '2e568d', color: 'ffffff' } },
        { text: "Non-Financial Value", options: { colspan: 1, align: "center", bold: true, fill: '2e568d', color: 'ffffff' } },
        { text: "Overall Value Score", options: { colspan: 1, align: "center", bold: true, fill: '2e568d', color: 'ffffff', border: [{ color: "000000", pt: 1 }, { type: "solid", color: "000000", pt: 2 }, { color: "000000", pt: 1 }, { color: "000000", pt: 1 }] } },
        { text: "Technical Feasibility", options: { colspan: 1, align: "center", bold: true, fill: '2e568d', color: 'ffffff' } },
        { text: "Internal Readiness", options: { colspan: 1, align: "center", bold: true, fill: '2e568d', color: 'ffffff' } },
        { text: "External Readiness", options: { colspan: 1, align: "center", bold: true, fill: '2e568d', color: 'ffffff' } },
        { text: "Overall Feasibility Score", options: { colspan: 1, align: "center", bold: true, fill: '2e568d', color: 'ffffff' } },
      ],
    ],
    SCORECARD_USE_CASE_DETAILS: {
      INFO_TABLE: [
        { text: "Industry", options: { bold: true } },
        { text: "Sub-Industry", options: { bold: true } },
        { text: "Business Function", options: { bold: true } },
      ],
      INFO_TABLE_FOR_CUSTOM: [
        { text: "Industry", options: { bold: true } },
        { text: "Business Function", options: { bold: true } },
      ],
      VALUE_TABLE: [
        [
          { text: "Business Value", options: { colspan: 5, align: "center", bold: true, } },
          { text: "Feasibility", options: { colspan: 4, align: "center", bold: true, } },
        ],
      ],
      DESCRIPTION_TITLE: 'Description',
      VALUE_SCORE_TITLE: 'Value Score',
      FEASIBILITY_TITLE: 'Feasibility Score',
    },
    BUSINESS_VALUE_TOOLTIP_TITLE: "Use-Case Dimension Explanations, Value",
    FEASIBILITY_TOOLTIP_TITLE: "Use-Case Dimension Explanations, Feasibility",
    TOOLTIP_TABLE: [
      ["Dimension", "Weights", "Explanation"],
    ],
    HOW_TO_USE: {
      TITLE: "How to Use",
      LINE_1:
        "This Use-Case Assessment plots use cases against business value and feasibility axes, inviting strategic conversations and driving investment decisions. ",
      LINE_2:
        "\nReview the generative AI use cases plotted on the graphic, comparing them with the maturity and requirements of your own CSP organization.",

      USE_CASE_INFO_TABLE: [
        { text: "Industry" },
        { text: "Sub-Industry" },
        { text: "Business Function" },
      ],
      USE_CASE_SCORE_CARD_TABLE: [
        [{ text: "Use Case Score Card", options: { colspan: 9, align: "center" } }],
        [
          { text: "Business Value", options: { colspan: 5, align: "center" } },
          { text: "Feasibility", options: { colspan: 4, align: "center" } },
        ],
      ],
      CALCULATED_RISK: {
        HEADER: "Calculated Risks",
        DESCRIPTION: " offer medium-to-high business value but low-to-medium feasibility. They represent riskier options.",
      },
      LIKELY_WINS: {
        HEADER: "Likely Wins",
        DESCRIPTION: " offer both medium-to-high feasibility and business value, making them wins in most circumstances."
      },
      MARGINAL_GAINS: {
        HEADER: "Marginal Gains",
        DESCRIPTION: " offer variable feasibility but are defined by their low value, making them more-selective options.",
      },
    },
  },
  ARIA: {
    SAVE_USECASE: "Save use case",
    UNSAVE_USECASE: "Unsave use case",
  },
  INTERCOM: {
    APP_ID: 'bkx1x7hl',
    TIMEOUT: 5000,
  },
  RATING_TABLE: {
    DIMENSION: "Dimension",
    DESCRIPTION: "Description",
    SCORE: "Score",
    WEIGHTS: "Weights",
    OVERALL_RATING: "Overall Rating: ",
    HEADER: "Scoring Breakdown",
    VIEW_SCORING_BREAKDOWN_CTA: "View Scoring Breakdown",
    USE_CASE_DIMENSION_EXPLANATION: "Use Case Dimension Explanation",
    MISSION_IMPACT: "Mission Impact",
    GOVERNMENT: "Government",
    RATIONALE: "Rationale",
    R_N_D: 'Research and Development',
    INNOVATION: 'Innovation',
    EXECUTIONAL_EXCELLENCE: 'Executional Excellence',
    DECISION_MAKING: 'Decision Making',

    RISK_MANAGEMENT_DESCRIPTION: "The potential of the use case to create agility to respond to future market disruptions and/or to remove uncertainty from the future performance of the organization by reducing potential financial, reputational, security or operational risks.",
    REVENUE_DESCRIPTION: "The potential of the use case to meet or exceed performance goals with equal or fewer resources, resulting in reduced costs and increased productivity.",
    NON_FINANCIAL_DESCRIPTION: "The potential of the use case to assist the organization in meeting its nonfinancial or mission-related goals. These goals can include the nonfinancial value of innovation; diversity, equity and inclusion; sustainability; and community development.",
    EFFICIENCY_DESCRIPTION: "The potential of the use case to meet or exceed performance goals with equal or fewer resources, resulting in reduced costs and increased productivity.",
    TECHNICAL_DESCRIPTION: "The organization’s ability to meet the technical requirements of a potential use case. Considerations include the core capabilities of the GenAI technology itself, the availability of vendor support, the current state of the organization’s technology infrastructure and the technical talent required by the use case.",
    INTERNAL_DESCRIPTION: "The organization’s ability and openness to use and incorporate a potential use case. This includes talent, operational readiness, and the willingness of internal stakeholders to understand, trust and effectively execute the use case.",
    EXTERNAL_DESCRIPTION: "The extent to which the environment outside of the organization is conducive to successful execution of the potential use case. This includes consideration of the legal and regulatory environment; public opinion of the use case; and the digital access, literacy and engagement required by the use case.",
  },
  USE_CASE_SORTING: {
    DEFUALT_OPTION: "recommendation",
    SORT_BY_TITLE: "Sort by",
  },
  CUSTOMIZE_WEIGHTS_DRAWER: {
    HEADER: 'Customize Dimension Weights',
    HEADER_DESC: 'Keep weights consistent for all your use cases',
    SUB_HEADER_1: 'Dimension weightings help determine Business Value and Feasibility scores, which define what category a use case sits within (e.g., Likely Wins). Gartner analysts configure the weightings of each dimension based on functional and/or vertical needs and priorities.',
    SUB_HEADER_2: "Use the table below to overwrite Gartner's default weightings, which may vary across use cases. Set consistent weightings aligned to your organization's priorities for all use case dimensions, to create a consistent comparison of your selected  use cases.",
    SUB_HEADER_3: 'When customized, the new weightings may change the positions and categories of use cases. To reset back to Gartner default scores, use the CTA below.',
    SUB_HEADER_LINK: 'https://intercom.help/use-case-insights/en/articles/10062864-details-of-gartner-s-assessment-parameters-and-weightages',
    SUB_HEADER_LINK_TEXT: 'View details for use case dimensions and weightings',
    INFO_BANNER_TEXT: 'Saving these changes will impact all Use Cases on the assessment. Default weights can be restored anytime.',
    COLUMN_1_TEXT: 'Dimensions',
    COLUMN_2_TEXT: 'Weights',
    REVENUE_TEXT: 'Revenue',
    EFFICIENCY_TEXT: 'Efficiency',
    MANAGED_RISK_TEXT: 'Managed Risk',
    NON_FINANCIAL_TEXT: 'Non Financial',
    TECHNICAL_FEASIBILITY: 'Technical Feasibility',
    INTERNAL_READINESS: 'Internal Readiness',
    EXTERNAL_READINESS: 'External Readiness',
    TOTAL_WEIGHT_TEXT: 'Total weight',
    TOTAL_WEIGHT_ERROR: 'Total weight must equal 100%',
    SAVE_CTA: 'Save Dimension Weights',
    INPUT_KEYS: {
      REVENUE: 'revenue',
      EFFICIENCY: 'efficiency',
      MANAGE_RISKS: 'managedRisks',
      NON_FINANCIAL: 'nonFinancial',
      TECHNICAL_FEASIBILITY: 'technicalFeasibility',
      INTERNAL_READINESS: 'internalReadiness',
      EXTERNAL_READINESS: 'externalReadiness',
    },
    BUSINESS_VALUE_KEYS: ['revenue', 'efficiency', 'managedRisks', 'nonFinancial'],
    FEASIBILITY_KEYS: ['technicalFeasibility', 'internalReadiness', 'externalReadiness'],
    INPUT_KEYS_MAP: {
      'revenue': 'weightIncreaseRevenue',
      'efficiency': 'weightIncreaseEfficiency',
      'managedRisks': 'weightManageRisk',
      'nonFinancial': 'weightNonFinancialValue',
      'technicalFeasibility': 'weightTechnicalFeasibility',
      'internalReadiness': 'weightInternalReadiness',
      'externalReadiness': 'weightExternalReadiness',
    },
    RESTRICTED_INPUT_REG_EX1: /^[0-9](\.\d{0,2})?$/,
    RESTRICTED_INPUT_REG_EX2: /^[0-9][0-9](\.\d{0,2})?$|^100$/,
    PERCENTAGE_SIGN: '%',
    SAVE_SUCCESS_TOASTER_MESSAGE: 'Parameter weights applied to the assessment.',
    RESET_SUCCESS_TOASTER_MESSAGE: 'Your weights have been reset to the default values.',
    NA_VALUE: 'NA',
    PLACEHOLDER_TEXT: '-',
    RESET_TO_DEFAULT: 'Reset to Default',
  },
  USE_CASE_DETAILS_SIDE_DRAWER: {
    VIEW_MORE_DETAILS: 'View More Details',
  },
  WHATS_NEXT: {
    HEADER: "What's next?",
    CARD_1_TITLE: 'Explore and Add more Use Cases',
    CARD_2_TITLE: 'Compare and Prioritize for your Organization',
    USECASE_LINK_TITLE: 'Back to Top',
    USECASE_DETAILS_LINK_TITLE: 'Use Case Details',
    DASHBOARD_LINK_TITLE: 'Go to Assessments',
  },
  SHARE_DIALOG: {
    HEADER: 'Share "##USE_CASE_NAME##"',
    USE_CASE_NAME: '##USE_CASE_NAME##',
    EMAIL_HEADER: 'Enter email address',
    EMAIL_PLACEHOLDER: 'Type email to share with others',
    EMAIL_MAX_LIMIT: 30,
    EMAIL_INFO: 'Only users with an AI Use Case Insights license can access this content.',
    MESSAGE_TEXT: 'Message',
    OPTIONAL_TEXT: 'Optional',
    MESSAGE_PLACEHOLDER: 'Enter message',
    MESSAGE_ROWS: 4,
    MESSAGE_MAX_CHAR_COUNT: 200,
    CANCEL_BUTTON: 'Cancel',
    SHARE_BUTTON: 'Share',
    ERROR_MESSAGE: "Some users are not from your organization or don't have a valid license, please remove them to continue.",
    SUCCESS_TOASTER_MESSAGE: "Success! You've shared this document with your selected recipient(s).",
  },
  EXPERT_INQUIRY: {
    TITLE_FOR_USECASE: 'Get analyst advice on this use case',
    TITLE_FOR_CASE_EXAMPLES: 'Get analyst advice on this case example',
    DESCRIPTION_FOR_USECASE: "Talk to our analysts and get help navigating this use case so you can advance on your organization's critical priorities.",
    DESCRIPTION_FOR_CASE_EXAMPLES: "Talk to our analysts and get help navigating this case example so you can advance on your organization's critical priorities.",
    BUTTON: 'Schedule Your Consultation',
    LINK: '/analyst-inquiry/?ref=aiusecaseinsights-inquiry',
    MEET_OUR_EXPERTS: 'Meet our analysts',
    MORE_EXPORTS: 'more analysts',
    CTA_TITLE_IN_ASSESSMENT: "Analyst Consultation"
  },
  SCORECARD_FILTER_DRAWER: {
    HEADER: 'Filters',
    FIELDS: [
      "BUSINESS_FUNCTIONS",
      "BUSINESS_VALUE_RATING",
      "FEASIBILITY_RATING",
      "INDUSTRY",
      "USE_CASE_CATEGORY",
    ],
    FILTERS_PAYLOAD: [
      { "label": "BUSINESS_FUNCTIONS", "filterValues": [] },
      { "label": "BUSINESS_VALUE_RATING", "filterValues": [] },
      { "label": "FEASIBILITY_RATING", "filterValues": [] },
      { "label": "INDUSTRY", "filterValues": [] },
      { "label": "USE_CASE_CATEGORY", "filterValues": [] },
    ],
    FIELDS_LABEL: {
      BUSINESS_FUNCTIONS: 'Business Function',
      BUSINESS_VALUE_RATING: 'Business Value',
      FEASIBILITY_RATING: 'Feasibility',
      INDUSTRY: 'Industry',
      USE_CASE_CATEGORY: 'Use Case Category',
    },
    APPLY_CTA: 'Apply',
    CLEAR_CTA: 'Clear Filter',
    CLEAR_ALL_CTA: 'Clear All',
  },
  CASE_EXAMPLES: {
    HEADING_TITLE: "Case Examples",
    HEADING_SUBTITLE: "Real-world examples showing how organizations are applying AI to solve problems and drive measurable impact.",
    SAVE: 'Save',
    TAG: "Tags",
    INDUSTRY: "Industry",
    BUSINESS_FUNCTION: "Business Function",
    VALUE_INDICATOR: "Value Driver",
    TAGGED_USECASES_HEADER: "Associated Use Cases",
    PPT_CASE_EXAMPLE_HEADER: "Case Example",
    FILTERS: {
      FIELDS: ["businessFunctions", "industries", "valueIndicators"],
      EXPAND_FIELDS: {
        businessFunctions: true,
        industries: true,
      },
      LABELS: {
        industries: "INDUSTRY",
        businessFunctions: "BUSINESS_FUNCTIONS",
        valueIndicators: "VALUE_INDICATOR",
      }
    },
    TOASTER_MESSAGE: {
      SAVE: "Case Example has been saved",
      UNSAVE: "Case Example has been unsaved"
    },
    SEARCH: {
      PLACEHOLDER_TEXT: "Search Case Examples by keywords"
    },
    CASE_EXAMPLE_TITLE_LIMIT: 70,
    RELATED_CASE_EXAMPLES: "Related Case Examples",
  },
  HOME_PAGE: {
    NEW_USER_WELCOME: "Welcome,",
    EXISTING_USER_WELCOME: "Welcome back,",
    BANNER: {
      COUNT: "##COUNT##",
      USE_CASES: {
        DESC: "Discover, evaluate, and prioritize high-impact AI opportunities using Gartner research, frameworks, and real-world case studies.",
        DESC_LIST_1: "Explore ##COUNT##+ AI use cases",
        DESC_LIST_2: "Identify top AI opportunities based on expert assessments",
        DESC_LIST_3: "View top use cases curated by experts across 30+ domains",
      },
      CASE_EXAMPLES: {
        HEADER: "Real-World Examples",
        DESC: "Explore case examples from real-world companies leveraging AI to solve a specific challenge.",
        DESC_LIST_1: "Explore ##COUNT##+ case examples of AI implementations in action",
        DESC_LIST_2: "See how your peer companies used AI to achieve business impact",
      }
    },
    FEATURED_USE_CASES: "Featured Use Cases",
    VIEW_ALL_CTA: "View All",
    ASSESSMENT_HEADER: "AI Use-Case Assessment :",
    ASSESSMENT_DESCRIPTION: "This use case assessment identifies ##TOTAL_USE_CASES## of the most prominent AI use cases for ##ASSESSMENT_TAG##, measuring them against business value and feasibility.",
    TOTAL_USE_CASES_PLACEHOLDER: "##TOTAL_USE_CASES##",
    ASSESSMENT_TAG_PLACEHOLDER: "##ASSESSMENT_TAG##",
    PUBLISHED: "Published:",
    EXPLORE_NOW_CTA: "Explore Now",
    FEATURED_CASE_EXAMPLES: "Featured Case Examples",
    USE_CASE_ASSESSMENTS: {
      HEADER: "Gartner's Assessments",
      SELECTION_HEADER: "View prominent AI use cases plotted on value and feasibility axes.",
      DEFAULT_SELECTION_RADIO_OPTION_ID: "industries",
      SELECTION_RADIO_OPTIONS: [
        { optionId: "industries", optionLabel: "Industry" },
        { optionId: "functions", optionLabel: "Function" },
      ],
      ASSESSMENT_DROPDOWN_HEADER: "Assessment",
      ASSESSMENT_DROPDOWN_ID: "assessments",
      DROPDOWN_PLACEHOLDER: "Select one",
      CLEAR_SELECTION: "Clear Selection",
      NO_SELECTED_ASSESSMENT: {
        HEADER: "No Data Selected",
        DESC: "Select industry or function to see the assessment",
      },
      SELECTED_ASSESSMENT: {
        HEADER: "AI Use-Case Assessment for",
        DESC: "This use case assessment identifies ##TOTAL_USE_CASES## of the most prominent AI use cases for ##ASSESSMENT_TAG##, measuring them against business value and feasibility. ##ASSESSMENT_TAG## professionals can use this assessment to guide strategic conversations for investment priority decisions for this technology."
      },
      VIEW_ASSESSMENT: "View Full Assessment",
      DROPDOWN_PLACEHOLDER_INDUSTRY: "Select Industry",
      DROPDOWN_PLACEHOLDER_FUNCTION: "Select Function",
      DROPDOWN_SELECTED_VALUE_MAX_LENGTH: 24,
      TOOLTIP_CONTENT: {
        LINE_1: "Structured use case comparison frameworks to help you prioritize AI use cases based on value and feasibility.",
        LINE_2: "Choose from a curated list of Use Cases below or create your own assessment from scratch.",
      },
      LEARN_MORE: "Learn more",
      LEARN_MORE_LINK: "https://intercom.help/use-case-insights/en/articles/10095757-how-are-use-cases-evaluated-and-rated-by-gartner",
    },
    ASSESSMENT_CALLOUT_TEXT: "This use case is part of the AI Use-Case Assessment for",
    ASSESSMENT_DASHBOARD_CARD: {
      HEADER: "Use Case Assessment Dashboard",
      SUB_HEADER: "Manage your active assessments or create a new one from scratch",
      BUTTON_TEXT: "Go to Assessments",
    }
  },
  GARTNER_ASSESSMENTS: {
    BREADCRUMB_STEP_1_LINK: "Assessments",
    BREADCRUMB_STEP_2_TEXT: "Use Cases for ",
    HOW_SCORING_WORKS: "How Scoring Works?",
    HOW_SCORING_WORKS_LINK: "https://intercom.help/use-case-insights/en/articles/10649674-how-scoring-works",
    VIEW_INSIGHTS: "View Insights",
    DESCRIPTION: "This use case assessment identifies ##TOTAL_USE_CASES## of the most prominent AI use cases for ##ASSESSMENT_TAG##, measuring them against business value and feasibility.",
    PUBLISHED_DATE: "Published Date",
    AUTHOR: "Author",
    DONWLOAD_EXCEL_CTA: "Download Assessment toolkit",
    DONWLOAD_PPT_CTA: "Download Assessment PPT",
    USE_THIS_ASSESSMENT_CALLOUT_TEXT: "Use this <b>Gartner's assessment</b> as a starting point to quickly evaluate and prioritize use cases for your organization.",
    USE_THIS_ASSESSMENT_CALLOUT_BUTTON: "Build Your Own Assessment",
  },
  CREATE_YOUR_ASSESSMENT: {
    HEADER: "Name Your Assessment",
    CANCEL_CTA: "Cancel",
    CREATE_CTA: "Create",
    MAX_CHAR_COUNT: 48,
    PLACEHOLDER: 'Enter Name',
    SUCCESS_TOASTER_MESSAGE: "You have successfully added ##ASSESSMENT_NAME## to your assessment library.",
    ASSESSMENT_NAME_REPLACE: "##ASSESSMENT_NAME##"
  },
  IMPORT_USE_CASES: {
    HEADER: "Import Use Cases",
    CUSTOM_TAG: "My Use Case",
    STEPPER_NUMBER: {
      INITIAL_VALUE: -1,
      IMPORT_AND_REVIEW: 0,
      FILL_WEIGHTS: 1,
      APPLY_SCORING: 2,
    },
    STEPPER_TITLE: {
      IMPORT_AND_REVIEW: "Import & Review",
      FILL_WEIGHTS: "Fill Weights",
      APPLY_SCORING: "Apply Scoring",
    },
    FOOTER_BUTTONS: {
      BACK: "Back",
      NEXT: "Next",
      FINISH_SCORE_LATER: "Finish & Score Later",
      FINISH: 'Finish'
    },
    IMPORT_STEP: {
      HEADER: "Import your use cases",
      DOWNLOAD_TEMPLATE: {
        INFO: "Use our Excel template to ensure your requirements import correctly.",
        CTA: "Template",
        FILE_NAME: "My Use Cases Template.xlsx",
        SUCCESS_TOASTER_MESSAGE: "Template downloaded successfully.",
        FAILURE_TOASTER_MESSAGE: "Download failed. Please try again later."
      },
      UPLOAD: {
        DRAG_DROP_ACTION: 'Browse File',
        DRAG_DROP_MESSAGE: 'Drag and drop files here',
        DRAG_DROP_SEPARATOR: "or",
        FILE_SIZE_INFO: "Max 1 file, 15 MB",
        SUPPORTED_FILES_INFO: "(Supported files types: .xlsx)"
      },
      UPLOAD_INSTRUCTIONS: {
        HEADER: "Template Instructions",
        VALUES_TITLE: "To add your use cases to the assessment,",
        VALUES: [
          "<b>Download the template</b> using the link in the top right corner.",
          "Add both the <b>Industry</b> and <b>Function</b> of your Use Cases, from the drop down list <b>(mandatory)</b>",
          "Add both <b>Use Case Names</b> and their <b>description. (mandatory)</b>",
          "<b>Special characters</b> (such as @ ! # $) are <b>not permitted.</b>",
          "Ensure the file extension remains <b>.xls</b>.",
          "<b>Upload your file</b> by dragging and dropping or by using <b>Browse File</b> in the box above.",
          "<b>Maximum of 20 use cases</b> allowed",
        ]
      },
      VALIDATION_PROGRESS: {
        HEADER: "Validation in Progress",
        INSTRUCTION: "You can stay on this page until validation is complete."
      }
    },
    REVIEW_STEP: {
      HEADER: "Imported Use Cases",
      IMPORTED_ON: "Imported on",
      SUMMARY_HEADER: "Summary",
      VIEW_BUTTON: 'View',
      SUMMARY_INFO: [{
        DESC: "Rows in file",
      }, {
        DESC: "Needs Action",
        TAG: "Action Required",
        TAG_CATEGORY: "actionRequired",
        TOOLTIP_TEXT: "We found an existing use case that looks similar. Choose which one to add."
      }, {
        DESC: "Ready to Proceed",
        TAG: "Ready",
        TAG_CATEGORY: "ready",
      }, {
        DESC: "Couldn't Import",
        TAG: "Error",
        TAG_CATEGORY: "error",
        TOOLTIP_TEXT: "There rows are missing required information, so they weren't imported. Fix them in your file and import again."
      }],
      TAG_CATEGORIES: {
        actionRequired: 'Action Required',
        ready: 'Ready',
        error: 'Error'
      },
      READY_TO_PROCEED: {
        HEADER: "Ready to Proceed",
        CATEGORY: "ready"
      },
      COULDNT_IMPORT: {
        HEADER: "Couldn't Import",
        CATEGORY: "error",
        ROW_TEXT: 'Row'
      },
      SIMILAR_USE_CASES: {
        HEADER: "Similar Use Cases",
        CATEGORY: "actionRequired",
        GARTNER_LIBRARY_HEADER: "We have found similar use case in Gartner's Library",
        GARTNER_LIBRARY_TAG: "Gartner Library",
        GARTNER_LIBRARY_PROS_TAGS: ["Comes Pre-scored", "Replaces your upload"],
        KEEP_YOUR_USE_CASE_CTA: "Keep your use case",
        REPLACE_WITH_GARTNER_CTA: "Replace with Gartner",
        RESOLUTION_PAYLOAD: {
          REPLACE_WITH_GARTNER: { "resolution": "REPLACE_WITH_GARTNER" },
          KEEP_CUSTOM: { "resolution": "KEEP_CUSTOM" }
        },
      },
      IMPORT_STATUS: {
        VALIDATING: "VALIDATING",
        READY: "READY",
      }
    },
    FILL_WEIGHTS: {
      HEADER: "Set the weights and scope",
      DESCRIPTION: "Pre-filled from your profile and the assessment defaults. Applies to every use cases.",
      INFO_BANNER: {
        CUSTOMISED: "Custom weights have been applied to the assessment dimensions and are shown below. Editing them here sets the dimension weights for your imported use cases as well as the assessment.",
        DEFAULT: "Editing dimension weights here sets the weights for your imported use cases as well as the assessment.",
      }
    },
    APPLY_SCORING: {
      HEADER: "Score Each Use Case",
      DESCRIPTION: "Pre-filled from your profile and the assessment defaults. Applies to every use cases.",
      USE_CASES_HEADER: "Use Cases",
      TAG_CATEGORIES: {
        REPLACE_WITH_GARTNER: "replaceWithGartner",
        KEEP_CUSTOM: "custom"
      },
      TAG_CATEGORIES_TEXT: {
        REPLACE_WITH_GARTNER: "Replaced - Gartner",
        KEEP_CUSTOM: "My Use Case"
      },
      COMPLETE_TAG: 'Complete',
      OVERALL_TEXT: "Overall:",
      BUSINESS_VALUE_FIELDS: [
        { label: 'Revenue', key: 'businessValueIncreaseRevenue', tooltip: "The potential of the use case to deliver additional revenue streams to the organization through the sale of products and services, government allocations, or grant funding that will result in top-line growth." },
        { label: 'Efficiency', key: 'businessValueIncreaseEfficiency', tooltip: "The potential of the use case to meet or exceed performance goals with equal or fewer resources, resulting in reduced costs and increased productivity." },
        { label: 'Managed Risk', key: 'businessValueManageRisk', tooltip: "The potential of the use case to create agility to respond to future market disruptions and/or to remove uncertainty from the future performance of the organization by reducing potential financial, reputational, security or operational risks." },
        { label: 'Sub-Industry', key: 'businessValueNonFinancialValue', tooltip: "The potential of the use case to assist the organization in meeting its nonfinancial or mission-related goals. These goals can include the nonfinancial value of innovation; diversity, equity and inclusion; sustainability; and community development." },
      ],
      FEASIBILITY_FIELDS: [
        { label: 'Technical', key: 'feasibilityTechnical', tooltip: "The organization's ability to meet the technical requirements of a potential use case. Considerations include the core capabilities of the GenAI technology itself, the availability of vendor support, the current state of the organization's technology infrastructure and the technical talent required by the use case." },
        { label: 'Internal Readiness', key: 'feasibilityInternalReadiness', tooltip: "The organization's ability and openness to use and incorporate a potential use case. This includes talent, operational readiness, and the willingness of internal stakeholders to understand, trust and effectively execute the use case." },
        { label: 'External Readiness', key: 'feasibilityExternalReadiness', tooltip: "The extent to which the environment outside of the organization is conducive to successful execution of the potential use case. This includes consideration of the legal and regulatory environment; public opinion of the use case; and the digital access, literacy and engagement required by the use case." },
      ],
      SCORING_VALUES: ['None', 'Low', 'Medium', 'High'],
      UNASSESSED_SCORE_VALUE: "Unassessed",
    },
    CANCEL_MODAL_ON_BACK: {
      HEADER: "Are you sure, you want to cancel?",
      DESCRIPTION: "Cancelling will also remove all the uploaded use cases.",
      NO_CTA: "No",
      CONFIRM_CTA: "Confirm",
    },
    DELETE_MODAL: {
      HEADER: "Remove this file?",
      DESCRIPTION: "Removing this file will also remove all the uploaded use cases.",
      CANCEL_CTA: "Cancel",
      REMOVE_CTA: "Remove",
    },
    TASK_IN_PROGRESS_MODAL: {
      HEADER: "Task in Progress",
      DESCRIPTION: "You have an unfinished task. If you leave now, your changes may not be saved. Are you sure you want to continue?",
      NO_CTA: "No",
      YES_CTA: "Yes",
    }
  }
};

export default Constants;
